import { withInstall } from '@/utils'
import CosMergeButton from './src/cosMergeButton.vue'
export default withInstall(CosMergeButton)
